export default "__VITE_ASSET__3a404161__"